export default __webpack_public_path__ + "static/media/SR_4.355d221c.png";